import * as angular from 'angular';
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import DataPointServiceName, {DataPointService} from "../../services/dataPoints/dataPoints.service";
import * as _ from "lodash";
import template from './formulaTester.tpl.html';

let requires = [NotifyServiceName, LoaderServiceName, DataPointServiceName];

export interface FormulaTesterParams {
  formula: string;
  variables: string[];
}

export function openFormulaTester(data: FormulaTesterParams,
                                  $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'FormulaTesterCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

interface FormulaTesterController {
  formula: string;
  values: {
    key: string;
    value: number;
  }[];
  result: number;
  errors: string[];
  form: angular.IFormController;
  test(): void;
  cancel(): void;
}

export default angular.module('aps.controller.formulaTester', requires)
  .controller('FormulaTesterCtrl', formulaTester)
  .name;

function formulaTester(
  data: FormulaTesterParams,
  dataPointService: DataPointService,
  $modalInstance: mm.foundation.modalInstance,
  notifyService: NotifyService,
  loaderService: LoaderService
): FormulaTesterController {
  let vm = <FormulaTesterController>{
    formula: data.formula,
    errors: [],
    result: null,
    values: _.map(data.variables, v => {
      return {key: v, value: 1};
    })
  };

  vm.test = () => {
    if (vm.form.$invalid) {
      return;
    }

    vm.errors = [];
    vm.result = null;

    let promise = dataPointService.validateFormula({
      formula: vm.formula,
      variableNames: _.map(vm.values, 'key')
    }).then(errors => {
      if (errors.length > 0) {
        vm.errors = errors;
        return;
      }

      return dataPointService.calculateFormula({
        formula: vm.formula,
        variables: vm.values
      }).then(result => {
        vm.result = result;
      }, () => errors = ['Unknown error occurred during calculation']);
    }, notifyService.handleApiErrors);

    loaderService.loadingPromise(promise);
  };

  vm.cancel = () => $modalInstance.close();

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/formulas/formulaTester.controller.ts